<div class="formfield">
  <nes-text class="nes-mb-2 use-product-label" weight="bold" color="blue" size="md">
    {{ "USER_DATA.INPUT.USE_PRODUCT.LABEL" | translate }}
  </nes-text>
  <p class="use-product-helptext">
    {{ "USER_DATA.INPUT.USE_PRODUCT.SUB_TEXT" | translate }}
  </p>

  <div class="">
    <ul [cypress]="'use_product'" class="list formfield__inputGroup">
      <li
        *ngFor="let input of useProduct"
        class="list__item formfield__inputGroupItem"
      >
        <div class="radioButton">
          <input
            [(ngModel)]="selectedProductUsage"
            (ngModelChange)="selected.emit($event)"
            [id]="input.value"
            [value]="input.value"
            type="radio"
            class="radioButton__input"
            name="radioGroupUseProduct"
          />
          <label
            class="radioButton__label nes-flex nes-items-center"
            [for]="input.value"
          >
            {{ input.displayText | translate }}
          </label>
        </div>
      </li>
      <ng-container *ngIf="selectedProductUsage === ProductStart.DATE">
        <div class="start-date-box">
          <span class="start-date-box__title">{{ 'USER_DATA.INPUT.USE_PRODUCT.START_DATE_TITLE' | translate }}</span>
          <span class="start-date-box__helptext">{{ 'USER_DATA.INPUT.USE_PRODUCT.START_DATE_HELP' | translate }}</span>
          <nes-datepicker-input
            class="start-date-box__picker"
            label=""
            [placeholder]="'USER_DATA.INPUT.USE_PRODUCT.START_DATE_PLACEHOLDER' | translate"
            modal-top="hi there"
            [value]="formattedDate"
            required
            nes-id="datepicker"
            (nesOnChange)="onDateChange($event)"
            [minDate]="minimalUseDate | dateFormat: 'YYYY-MM-DD'"
            [maxDate]="maximalUseDate | dateFormat: 'YYYY-MM-DD'"
          ></nes-datepicker-input>
          @if (!formattedDate && datePreviouslySet) {
            <div class="start-date-box__error">
              <svg class="start-date-box__error-icon" width="35" height="40" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill="#EC0045" d="M17.5,10.1L26.3,26H8.7L17.5,10.1 M17.5,8L7,27h21L17.5,8L17.5,8z"/>
                <path fill="#EC0045" d="M17.5,21c-0.3,0-0.5-0.2-0.5-0.5v-5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v5C18,20.8,17.8,21,17.5,21z"/>
                <circle fill="#EC0045" cx="17.5" cy="23.2" r="0.8"/>
              </svg>
              <span>{{ 'USER_DATA.INPUT.USE_PRODUCT.START_DATE_ERROR' | translate }}</span>
            </div>
          }
        </div>
      </ng-container>
    </ul>
  </div>
</div>
